import React from 'react';
import TripRequestConversationLinks from './TripRequestConversationLinks';
import { ConversationLinkProps } from './ConversationLink';
import { ConversationLinksCardProps } from './ConversationLinksCard';
import TripMatchConversationLinks from './TripMatchConversationLinks';

export type ConversationLinksProps = (
  | {
    tripMatchId: string;
    tripRequestId?: never,
    renderConversationLink: ConversationLinksCardProps['renderConversationLink']
    getConversationTypeTitle?: ConversationLinkProps['getConversationTypeTitle']
  }
  | {
    tripMatchId?: string;
    tripRequestId: string,
    renderConversationLink: ConversationLinksCardProps['renderConversationLink']
    getConversationTypeTitle?: ConversationLinkProps['getConversationTypeTitle']
  }
);

const ConversationLinks = ({
  tripMatchId,
  tripRequestId,
  renderConversationLink,
  getConversationTypeTitle,
}: ConversationLinksProps) => {
  if (tripMatchId && !tripRequestId) {
    return (
      <TripMatchConversationLinks
        tripMatchId={tripMatchId}
        renderConversationLink={renderConversationLink}
        getConversationTypeTitle={getConversationTypeTitle}
      />
    );
  } if (tripRequestId) {
    return (
      <TripRequestConversationLinks
        tripRequestId={tripRequestId}
        tripMatchId={tripMatchId}
        renderConversationLink={renderConversationLink}
        getConversationTypeTitle={getConversationTypeTitle}
      />
    );
  }

  return null;
};

export default ConversationLinks;
